import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, http } from "../../lib/api";
import { Btn, Card } from "../kit/Kit";
import { Vacio } from "./common";

const fh = (s) => (s ? new Date(s).toLocaleString("es-MX", { timeZone: "America/Mexico_City", dateStyle: "short", timeStyle: "short" }) : "—");

export const SesionCard = ({ s, onRevocar }) => (
  <div className="flex flex-wrap items-center justify-between gap-2 border-t border-[#F2F0EC] py-2.5" data-testid="bit-sesion">
    <div className="min-w-0 text-sm">
      <p className="font-medium">{s.user_name} {s.quick && <span className="rounded bg-[#FFF4E5] px-1.5 text-[10px] text-[#B4471F]">acceso rápido</span>}
        {!s.activa && <span className="ml-1 rounded bg-slate-100 px-1.5 text-[10px] text-slate-600">{s.motivo_revocacion || "cerrada"}</span>}</p>
      <p className="truncate text-xs text-[#5C5850]">{s.ip} · {s.dispositivo?.navegador} · {s.dispositivo?.so} · {s.dispositivo?.dispositivo}</p>
      <p className="text-[11px] text-[#8C867A]">Inicio {fh(s.inicio)} · Última actividad {fh(s.ultima_actividad)}{s.revocada_en && ` · Cerrada ${fh(s.revocada_en)} por ${s.revocada_por}`}</p>
    </div>
    {s.activa && onRevocar && <Btn kind="secondary" className="px-3 py-1.5 text-xs" onClick={() => onRevocar(s)} data-testid={`bit-revocar-${s.id}`}>Revocar</Btn>}
  </div>
);

export const Sesiones = ({ esMaster }) => {
  const [rows, setRows] = useState([]);
  const load = useCallback(() => http.get("/audit/sesiones").then((r) => setRows(r.data)).catch(() => setRows([])), []);
  useEffect(() => { load(); }, [load]);
  const revocar = async (s) => {
    try { await http.post(`/audit/sesiones/${s.id}/revocar`); toast.success(`Sesión de ${s.user_name} revocada`); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Card title={`${rows.length} sesiones activas`} subtitle="Revocar cierra la sesión de inmediato (el usuario debe volver a entrar)" testid="bit-sesiones">
      {rows.length ? rows.map((s) => <SesionCard key={s.id} s={s} onRevocar={esMaster ? revocar : null} />) : <Vacio />}
    </Card>
  );
};
